import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type PanelEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	Record<string, never>,
	Record<string, never>
>;

export const panelEntryPoint: EntryPoint<PanelEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<PanelEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/PanelEntryPointComponent" */ './PanelEntryPointComponent',
		{
			moduleId: 'panel-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
